import { Component } from '@angular/core';

@Component({
  selector: 'app-suppliers-configurations',
  templateUrl: './suppliers-configurations.component.html',
  styleUrls: ['./suppliers-configurations.component.css'],
})
export class SuppliersConfigurationsComponent {}
